import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// TICKET_CREATE

const mutation = gql`
  mutation ticketCreate($attributes: CreateTicketAttributesInput!) {
    ticketCreate(attributes: $attributes) {
      id
      title
      state {
        id
        code
        display_name
      }
      type {
        id
        code
        display_name
      }
      assigned_to {
        id
        first_name
        last_name
      }
      resource {
        ... on BenefitInquiryType {
          id
        }
        ... on AccumulatorIssueType {
          id
        }
        ... on DrugListUpdateRequestType {
          id
        }
        ... on VendorSetupType {
          id
        }
        ... on AccumulatorChangeType {
          id
        }
        ... on FertilityMaximumType {
          id
        }
        ... on GroupNumberChangeType {
          id
        }
        ... on PlanChangeHandlingType {
          id
        }
        ... on NewImplementationType {
          id
        }
        ... on GroupTermingType {
          id
        }
        ... on ClaimFileProcessingType {
          id
        }
        ... on ImpactReportType {
          id
        }
        ... on EligibilityInquiryType {
          id
        }
      }
      member {
        id
        first_name
        last_name
      }
    }
  }
`

export default function useTicketCreate(
  successMessage = 'Ticket was successfully created'
) {
  const { onMutate: onTicketCreate, loading } = useSafeRunMutation({
    mutation,
    successMessage,
    responsePath: 'ticketCreate'
  })

  return { onTicketCreate, loading }
}
